import type { ReactNode } from "react";
import styles from "./ErrorText.module.scss";

interface ErrorTextProps {
  children: ReactNode;
}

const ErrorText = ({ children }: ErrorTextProps) => {
  return <p className={styles.validationText}>{children}</p>;
};

export default ErrorText;
